import Validator from '../Validator';
import ValidatorInterface from '../ValidatorInterface';

export default class ValidatorLocale extends Validator implements ValidatorInterface {

    readonly VALID_LANGUAGE_TAGS = [
        'DUT-NL',
        'ENG-AU',
        'ENG-CA',
        'ENG-GB',
        'ENG-US',
        'FRE-FR',
        'GER-DE',
        'GER-CH',
        'ITA-IT',
        'POL-PL',
        'POR-BR',
        'POR-PT',
        'RUS-RU',
        'SPA-MX',
        'SPA-ES',
        'SWE-SE',
        'FRE-CA',
        'FRE-BE',
        'SPA-US',
        'DUT-BE',
        'NOR-NO',
        'DAN-DK',
        'FIN-FI',
        'FRE-CH',
        'ITA-CH',
        'GER-AT',
        'CZE-CZ',
        'GRE-GR',
        'ENG-IE',
        'LUX-LU',
        'ENG-NZ',
        'HUN-HU',
        'LAT-LV',
        'EST-EE',
        'LIT-LT',
        'SLK-SK',
        'SLV-SI',
        'GER-LU',
    ];

    /**
     * Check if value is valid
     *
     * @param value
     * @param index
     * @param offset
     */

    public check(value: string, index: number, offset: number): boolean {

        if (this.VALID_LANGUAGE_TAGS.includes(value.toUpperCase())) {
            return true;
        } else {
            this.addError("Invalid locale", index, value);
        }
        return true;
    }
}
